import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const typeOptions = [
    {value: '', label: 'Seleccione un tipo'},
    {value: 'CONTROLLER', label: 'Controlador'},
    {value: 'TANK', label: 'Tanque'},
    {value: 'DISPENSER', label: 'Dosificador'},
    {value: 'AGITATOR', label: 'Agitador'}
];

const stateOptions = [
    {value: 'AVAILABLE', label: 'Disponible'},
    {value: 'IN_USE', label: 'En Uso'},
    {value: 'BLOCKED', label: 'Bloqueado'}
];

export const getComponents = async (page: number, filters: any) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/components`, { params: {page, size: 10, ...filters },
            withCredentials: true
        });

        const transformedComponent = response.data.data.components.content.map((item: any) => ({
            NOMBRE: item.name,
            TIPO: typeOptions.find(option => option.value === item.type)?.label,
            CLAVE: item.uniqueCode,
            ESTADO: stateOptions.find(option => option.value === item.state)?.label,
            ID: item.id
        }));

        return {
            components: transformedComponent || [],
            page: response.data.data.components.number,
            totalPages: response.data.data.components.totalPages,
        }

    } catch (error) {
        throw error;
    }
}

export const addNewComponent = async (newComponentDTO: any) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/components`, newComponentDTO , {withCredentials: true});
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateComponent = async (updateComponentDTO:any, id:number) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/components/${id}`, updateComponentDTO , {withCredentials: true});
        return response.data;

    } catch (error) {
        throw error;
    }
}

export const getComponentById = async (id:number) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/components/${id}`, {withCredentials: true});
        return response.data;
    } catch (error) {
        throw error;
    }
}